module.exports = __webpack_public_path__ + "static/scale-model-of-travel-experience-international-in-richardson-texas-10ee9bd2593e17a81077bbb5d6bac67b.png";